module.exports = __webpack_public_path__ + "img/bannerPRINCIPAL1.ad7a858b.jpeg";